// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2WFGM","content":"LayoutSettings_content__2tl9-"};